/* eslint-disable no-console -- sole allowed console sink for local/dev diagnostics */
import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

import { CONSOLE_LOGGER_ENABLED } from './console-logger.token';

@Injectable({ providedIn: 'root' })
export class ConsoleLogger {
  readonly #document = inject(DOCUMENT);
  readonly #enabled = inject(CONSOLE_LOGGER_ENABLED);

  info(scope: string, message: string, data?: unknown): void {
    this.#write(console.log, scope, '--drf-color-action-active', message, data);
  }

  error(scope: string, message: string, data?: unknown): void {
    this.#write(console.error, scope, '--drf-color-danger-300', message, data);
  }

  #write(write: typeof console.log, scope: string, backgroundToken: string, message: string, data?: unknown): void {
    if (!this.#enabled) {
      return;
    }

    const badge = `background:${cssVar(this.#document, backgroundToken)};color:${cssVar(this.#document, '--drf-color-neutral-100')};padding:1px 6px;border-radius:4px;font-weight:600`;
    const label = `%c ${scope}`;

    if (data === undefined) {
      write(label, badge, message);

      return;
    }

    write(label, badge, message, data);
  }
}

function cssVar(documentRef: Document, name: string): string {
  return getComputedStyle(documentRef.documentElement).getPropertyValue(name).trim();
}
